// extracted by mini-css-extract-plugin
export default {"card":"_1-z"};